// 后端微服务端口名
export const PORT1 = ''
export const ADMIN = '/admin'
export const ORDER = '/order'
export const GOODS = '/goods'

